export default {
  payWelfareText: 'Yükleme Avantajları',
  blackFridayDiscount: 'Kara Cuma Süreli İndirim',
  shareGift: 'Hediye Paylaş',
  vipWeeklyWelfare: 'Haftalık VIP İndirimi',
  exchangeCoupon: 'Kupon',
  firstPayOff: "1. Alışverişte %15'e Varan İNDİRİM",
  blackFridayEvent: 'Kara Cuma Etkinliği',
  limitedTimeOff: 'Sınırlı Süreli %10 İNDİRİM',
  claimCoupon: 'Şimdi Talep Et',
  blackFridayTimedCoupon: 'Kara Cuma Süreli Kupon',
  timeLeft: 'Kalan süre:',
  claimTimeCoupon: 'Şimdi %10 İNDİRİM Kuponu Talep Et!',
  points: 'Puanlar: ${point}',
  costPointTip: 'Puanlarınızı kuponlarla değiştirin',
  maxPointTip: 'Her hesap 500 puana kadar kullanabilir.',
  discountOff: '%10 İNDİRİM',
  highestDiscount: '$${discount}’a varan İNDİRİM',
  needPoint: '${point} puan gerekir',
  changeCurrency: 'Para Birimini Değiştir',
  claim: 'Talep Et',
  claimSucc: 'Talep edildi',
  claimFail: 'Başarısız',
  pointNotEnough: 'Yetersiz puan',
  afterClaimPoint: 'Kalan puan: ${point}',
  footTips1: 'Her sipariş için sadece 1 kupon kullanılabilir.',
  footTips2: 'Kupon, oyun içi para birimi/jeton satın almak için kullanılamaz.',
  footTips3: 'Bu etkinliğin nihai yorum hakkı bizde saklıdır',
  ruleTitleText: 'Etkinlik Kuralları',
  ruleTime: 'Etkinlik Süresi: 24 Kasım 2023 00.00 - 26 Kasım 2023 23.59 (UTC)',
  bfRuleText1:
    '1. Etkinlik sırasında resmi yükleme sayfasına ilk kez giriş yaptığınızda hesabınıza 400 puan yüklenecektir. Kuponlar için 500 puana kadar değişim yapabilirsiniz.',
  bfRuleText2:
    '2. Etkinlik sırasında Kara Cuma puanlarınızı kuponlarla değiştirebilirsiniz.',
  bfRuleText3:
    '3. Her sipariş için yalnızca 1 kupon kullanabilirsiniz. Kuponlar oyun içi para birimi/jeton satın almak için kullanılamaz.',
  bfRuleText4:
    '4. İşlemler için yalnızca aşağıdaki para birimlerini kabul ediyoruz:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Bir işlem yapıldıktan sonra para birimini değiştiremezsiniz. Değiştirilen puanlar iade edilemez.',
  bfRuleText6: '6. Kara Cuma kuponları yalnızca 7 gün boyunca geçerli olacaktır.',
  bfRuleText7: '7. Bu etkinliğin nihai yorum hakkı bizde saklıdır.',
  thanksTip:
    'Katılımınız için teşekkür ederiz. Daha fazla etkinlik bilgisi için lütfen resmi topluluğumuza katılın.',
  exchangePoints: 'Değiştir',
  exchangeCode: 'Değişim kodunu girin.',
  enterExchangeCode: 'Lütfen değişim kodunu girin.',
  exchangeText: 'Değiştir',
  confirmGet: 'Onayla',
  couponUsedWay:
    'Kupon yalnızca belirli para birimleriyle kullanılabilir, lütfen para biriminizi onaylayın.',
  confirmText: 'Onayla',
  exchangeSucc: 'Değiştirildi',
  aboutCoins: 'Oyun İçi Para Birimi/Jeton Hakkında',
  aboutCoinsText:
    'Oyun içi para birimini/jetonunu, oyun içi para biriminin/jetonunun kendisi hariç tüm paketler ve ayrıcalıklar için takas edebilirsiniz.',
  known: 'TAMAM',
  codeText: 'Kod',
  codeInvalid: 'Kod geçersiz!',
  hasExchanged: 'Daha fazla kod talep edemezsiniz.',
  hideText: 'Gizle',
  //黑五的报错码
  'bf-20001': 'Giriş yapılmadı',
  'bf-20002': 'Parametre hatası. Lütfen etkinliğe yeniden girmeyi dene.',
  'bf-20003': 'Yetersiz puan',
  'bf-20004':
    'Başarısız! Lütfen daha sonra tekrar dene veya Müşteri Desteği ile iletişime geç.',
  'bf-20005': 'Talep edildi',
  'bf-20015': 'Etkinlik şu anda mevcut değil.',
  'bf-20016': 'Etkinlik sona erdi.',
  bfShareText: 'Şimdi %10 İNDİRİM Kuponu Talep Et!',
  rightsCenterBtn: 'Ayrıcalıklı Üye Merkezi',
  payBtn: 'TOP UP',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Olağanüstü Görkemli (Süresiz)',
  rightCenterNoticeTitle: "VIP Puan Sistemi Ayrıcalık Merkezi'ne Yükseltiliyor",
  rightCenterNoticeContent: 'Selamlar Kumandan!<br />Puzzles & Survival\'ı desteklediğiniz için teşekkür ederiz. Size daha da iyi bir ödül deneyimi sunmak için, mevcut VIP Puan Sistemi 16 Temmuz 2025 tarihinde yepyeni Ayrıcalıklı Üye Merkezi\'ne yükseltilecektir. Bu yeni sistem sadece mevcut VIP avantajlarını birleştirmekle kalmayacak, aynı zamanda bir dizi heyecan verici yeni avantaj da sunacak. İşte bilmeniz gerekenler:<br />1. Neler Değişiyor?<br />Haftalık Oturum Açma Avantajları Devam Ediyor<br />16-29 Temmuz 2025 tarihleri arasında oyuncular Resmi Yükleme Sayfasına giriş yaparak Haftalık VIP Kuponlarını almaya devam edebilirler. Kupon sayısı VIP Puan etkinliğinde olduğu gibi aynı kalacaktır. Bu arada, oyuncular Premium Üye Merkezinde maksimum indirim sınırı içeren yeni kuponları da kullanabilecekler. Yeni kupon kuralları ve kullanım limitleri hakkında daha fazla ayrıntı için bu bildirimin sonundaki tabloya bakın.<br />Not: Otomatik kupon kullanma özelliği manuel olarak etkinleştirilmelidir. Bunu yapmak için şu adrese gidin: Ayrıcalık Merkezi Ana Sayfası > Üye Avantajları > Kuponları Otomatik Kullan Etkinleştir > Otomatik Kullanılacak Kuponları Seç > Onayla.<br />Yeni Puan Değişimi Özelliği<br />Ayrıcalık Merkezi bir Puan Değişimi özelliği sunacak. Oyuna giriş yaparak veya belirlenen görevleri tamamlayarak puan kazanın, ardından bunları özel kuponlar, nadir öğeler ve diğer değerli ödüllerle değiştirin. (Öğe kullanım limitleri için Ayrıcalık Merkezi sayfasına bakın.)<br />VIP Seviyesi Devri<br />Mevcut VIP seviyeniz ve birikmiş VIP Puanlarınız yeni sisteme tamamen aktarılacaktır. Size otomatik olarak ilgili Ayrıcalık Merkezi kademesi atanacak ve mevcut tüm VIP avantajlarınız korunacak ve hatta geliştirilecektir.<br />2. Bu Yükseltme Neden Daha İyi?<br />Daha Net Avantajlar: Tüm ödül kuralları ve kullanım detayları açıkça gösterilir, böylece avantajlarınızı talep etmek her zamankinden daha kolay hâle gelir.<br />Daha Büyük Ödüller: Yeni puan değişim etkinliklerinin ve düzenli olarak güncellenen yüksek değerli öğelerin keyfini çıkarın.<br />Şanslı Çekilişler: Puan değişimine ek olarak, değerli oyun içi öğeler kazanma şansı veren şanslı çekiliş etkinlikleri de mevcut olacak.<br />3. Önemli Notlar<br />Geçiş dönemi boyunca (16-29 Temmuz 2025), orijinal VIP Puanları bölümü aşamalı olarak kaldırılacaktır. Bu süre zarfında her zamanki gibi kupon almaya ve kullanmaya devam edebileceksiniz. VIP Puan Etkinliği sona ermeden önce kalan kuponları kullandığınızdan emin olun. Kullanılmayan kuponların süresi dolacaktır.<br />Ayrıcalık Merkezi yayına girdikten sonra, şuraya giderek erişebilirsiniz: Resmi Yükleme Merkezi > Avatara Dokun > Ayrıcalık Merkezi.',
  rightCenterNoticeTableTitle: 'Kupon Değişiklikleri Karşılaştırması',
  rightCenterNoticeTableHeader1: 'Kullanım Koşulları - Ayrıcalıklı Üyelik Seviyesi',
  rightCenterNoticeTableHeader2: 'Orijinal VIP Seviyesi',
  rightCenterNoticeTableHeader3: 'Kupon İndirimi',
  rightCenterNoticeTableHeader4: 'Satın Alma Limiti',
  rightCenterNoticeTableHeader5: 'Maksimum İndirim Sınırı',
  rightCenterNoticeTableLevel1: 'Bronz',
  rightCenterNoticeTableLevel2: 'Gümüş',
  rightCenterNoticeTableLevel3: 'Altın',
  rightCenterNoticeTableLevel4: 'Platin',
  rightCenterNoticeTableLevel5: 'Elmas',
  rightCenterNoticeTableCount1: 'Günde bir kez',
  rightCenterNoticeTableCount2: '15 Kez/Ayda',
  rightCenterNoticeTableCount3: '10 Kez/Ayda',
  rightCenterNoticeTableLimit: '15 $',
  rightCenterNoticeTableTip: 'Not: Ayrıcalık Merkezi\'ndeki kupon indirim limitleri ABD doları bazındadır ve döviz kurlarına bağlı olarak değişebilir. Gerçek indirim tutarı kullanım sayfasında görüntülenecektir.',
  '-': '-'
};
